import { render } from "./AddModalFooter.vue?vue&type=template&id=7023e886"
import script from "./AddModalFooter.vue?vue&type=script&lang=js"
export * from "./AddModalFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__